<section class="hero-banner -m-2">
  <div class="hero-overlay"></div>
  <div class="hero-content relative z-10 flex flex-col items-center justify-center text-center text-white px-6 py-24 w-full">
    <h1 class="hero-title tracking-tight">Offshore and Inland Chartering</h1>
    <p class="hero-subtitle mt-4 text-gray-100">US-Flagged Vessels</p>
    <p class="max-w-2xl mt-6 text-base md:text-lg text-gray-100">
      Contracts of affreightment across the East, Gulf &amp; West Coasts, Puerto Rico and the Caribbean,
      and the inland river and intracoastal waterway systems.
    </p>
  </div>
</section>

<div class="max-w-6xl w-full mx-auto px-6 relative z-20 -mt-16 grid gap-6 md:grid-cols-3">
  <div class="card p-6">
    <div class="flex items-center justify-center h-11 w-11 rounded-lg bg-primary-50 text-primary-700 mb-4">
      <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 15h18M6 15V9a2 2 0 012-2h8a2 2 0 012 2v6M4 19h16" />
      </svg>
    </div>
    <h3 class="text-base font-semibold text-gray-900 m-0">Offshore Chartering</h3>
    <p class="text-sm text-gray-600 mt-2 mb-0">
      U.S.-flagged ships and offshore barges trading the East, Gulf and West Coasts, Puerto Rico and the Caribbean.
    </p>
  </div>
  <div class="card p-6">
    <div class="flex items-center justify-center h-11 w-11 rounded-lg bg-primary-50 text-primary-700 mb-4">
      <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 7h16M4 12h16M4 17h10" />
      </svg>
    </div>
    <h3 class="text-base font-semibold text-gray-900 m-0">Inland Chartering</h3>
    <p class="text-sm text-gray-600 mt-2 mb-0">
      The Mississippi, Illinois, Missouri, Ohio and Tennessee Rivers, the Tenn-Tom and the Gulf Intracoastal Waterways.
    </p>
  </div>
  <div class="card p-6">
    <div class="flex items-center justify-center h-11 w-11 rounded-lg bg-primary-50 text-primary-700 mb-4">
      <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <h3 class="text-base font-semibold text-gray-900 m-0">Operations &amp; Documentation</h3>
    <p class="text-sm text-gray-600 mt-2 mb-0">
      Day-to-day operations, equipment tracking, inventory management, market research and required follow-up.
    </p>
  </div>
</div>

<div class="max-w-4xl mx-auto px-6 my-16 md:my-20 text-lg leading-relaxed text-gray-700 space-y-6">
  <p class="font-medium text-gray-900">L & R Midland’s Offshore and Inland Chartering departments are skilled in all manner of contracts of affreightment.  We assist both owners and charterers in the transport of Oil products both clean and dirty, clean and water white chemicals and petrochemicals.</p>
  <p>Offshore includes U.S. Flagged ships and offshore barges trading the East Coast, Gulf Coast and West Coast as well as Puerto Rico and the Caribbean.  Inland comprises the Mississippi, Illinois, Missouri, Ohio, and Tennessee Rivers as well as the Tennessee-Tom Bigbee Waterway and the Gulf Intercoastal Waterways.</p>
  <p>Our experienced Chartering Departments provide day-to-day operations, tracking equipment and assist with daily issues as they arise along with the proper documentation and required follow up.. They also provide the unique services of offering inventory management and market research.</p>
  <p>Brokering petrochemicals and petroleum product freight, spot and time charters, affreightment, bareboat charter both for brown and blue water.</p>
</div>
